import { useHistory } from 'react-router-dom';
import { useStyles } from '../style';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const StylePreferenItem = (props) => {
    const { isDisableLink, prefix, path, styleName } = props;
    const classes = useStyles();
    const history = useHistory();

    const handleClick = () => {
        if (isDisableLink) {
            return;
        }

        history.push(path);
    };

    return (
        <li className={classes.optionChild} onClick={handleClick}>
            {prefix} {styleName}{' '}
            <span>
                <ArrowForwardIosIcon className={classes.arrowIcon} />
            </span>{' '}
        </li>
    );
};

export default StylePreferenItem;
